 
window.addEventListener("load", (event) => {
  
 var parenttesti = document.querySelectorAll('section#shopify-section-template--18175382585499__65e76dce-e754-48ff-bec2-b801a0e838c2>div.testtti>div>div.row>div.testimonial-block-bg');
  var sideimg1 = document.createElement('img');  
  var sideimg2 = document.createElement('img'); 
  sideimg1.classList.add('sideimg1');
  sideimg2.classList.add('sideimg2');
  sideimg1.src = "https://cdn.shopify.com/s/files/1/0682/0370/8571/files/tripbag.png?v=1741677328";
  sideimg2.src = "https://cdn.shopify.com/s/files/1/0682/0370/8571/files/tower.png?v=1741677407";
if(parenttesti[0]){
  
  parenttesti[0].appendChild(sideimg1);
  parenttesti[0].appendChild(sideimg2);
}


  // product page code
 setTimeout(() => {

    // var ftslider__footer = document.getElementsByClassName('ft-slider__footer');
    // var nthanksdv = document.createElement('div');
    // nthanksdv.classList.add('no_thanks');

    // var noacn = document.createElement('span');
    // noacn.classList.add('no_thanks_btn');
    // noacn.setAttribute('onclick','hideFBT()');
    // noacn.innerHTML ="No Thanks";
    // nthanksdv.appendChild(noacn);
    // ftslider__footer[0].appendChild(nthanksdv);
    
  }, 1000);

  setTimeout(() => {
    var hideUntil = localStorage.getItem('hideFBT_until');
    var now = new Date().getTime();
    // If a hide time is set and it's in the future, hide the div
    if(hideUntil && now < hideUntil){
        var FBTdv = document.getElementById('shopify-block-AbmtZZUl3OGdWVVBQN__ft_frequently_bought_together_widget_block_jRiDTQ');
        if(FBTdv){
            FBTdv.style.display = 'none';
        }
    }
     console.log('take setTimeout');
  }, 1000);
  
// product page code ends
  console.log("page is fully loaded");
});
function hideFBT(){
    var FBTdv = document.getElementById('shopify-block-AbmtZZUl3OGdWVVBQN__ft_frequently_bought_together_widget_block_jRiDTQ');
    if(FBTdv){
        FBTdv.style.display = 'none';
        // Store the time until which the div should be hidden (e.g., 1 day from now)
        var now = new Date().getTime();
        var hideDuration = 24 * 60 * 60 * 1000; // 1 day in milliseconds
        localStorage.setItem('hideFBT_until', now + hideDuration);
    }
}
 const accordionItemh = document.querySelectorAll(".ko-accordion-item-header");
  accordionItemh.forEach((accordionItemh) => {
    accordionItemh.addEventListener("click", (event) => {
      // Uncomment in case you only want to allow for the display of only one collapsed item at a time!

      //     const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");
      //     if(currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader!==accordionItemHeader) {
      //        currentlyActiveAccordionItemHeader.classList.toggle("active");
      //        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      //      }
      accordionItemh.classList.toggle("active");
      const accordionItemBody = accordionItemh.nextElementSibling;
      if (accordionItemh.classList.contains("active")) {
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });
document.addEventListener('DOMContentLoaded', function () {
  // Run only on homepage ("/" or "/index.html")
  if (window.location.pathname !== '/' && window.location.pathname !== '/index.html') return;

  const swiperContainer = document.querySelector('grid-slider .swiper');

  // Exit if slider not found
  if (!swiperContainer) return;

  // Avoid adding buttons multiple times
  if (document.querySelector('.swiper-buttons')) return;

  // 1. Create Prev/Next buttons
  const navWrapper = document.createElement('div');
  navWrapper.className = 'swiper-buttons';
  navWrapper.innerHTML = `
    <button class="swiper-button-prev xdswipebtn">←</button>
    <button class="swiper-button-next xdswipebtn">→</button>
  `;

  // 2. Insert buttons after swiper
  swiperContainer.parentNode.insertBefore(navWrapper, swiperContainer.nextSibling);

  // 3. Attach buttons to existing Swiper instance if it exists
  if (typeof Swiper !== 'undefined') {
    // Try connecting to existing Swiper instance
    const swiperInstance = swiperContainer.swiper;

    // If already initialized, just hook in buttons
    if (swiperInstance) {
      swiperInstance.params.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      };
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    } else {
      // If not initialized (edge case), initialize manually
      new Swiper(swiperContainer, {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 5,
        spaceBetween: 30,
        breakpoints: {
          320: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
          1200: { slidesPerView: 5 }
        }
      });
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const closeBtn = document.querySelector('.header-drawer__close.close_icon_button');
  if (!closeBtn) return;

  closeBtn.addEventListener('click', function() {
    // 1) Remove 'submenu-open' from each <ul>
    const menus = document.querySelectorAll('nav.menu-drawer__navigation > ul.menu-drawer__menu');
    for (let i = 0; i < menus.length; i++) {
      menus[i].classList.remove('submenu-open');

      // 2) Within this menu, handle each <details>
      const detailsList = menus[i].querySelectorAll('li > details');
      for (let j = 0; j < detailsList.length; j++) {
        const det = detailsList[j];

        // a) Close the <details>
        det.removeAttribute('open');

        // b) Remove the 'menu-opening' class
        det.classList.remove('menu-opening');

        // c) Inside this details, make its sub-menu-block visible
        const blocks = det.querySelectorAll('.menu-drawer__inner-submenu > div.sub-menu-block');
        for (let k = 0; k < blocks.length; k++) {
          blocks[k].classList.remove('is-hidden');
        }
      }
    }

    // Let the theme’s own close behavior run too
  });
});




